function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("filter", {
  id: "a",
  width: "132%",
  height: "104.1%",
  x: "-16%",
  y: "-2.1%",
  filterUnits: "objectBoundingBox"
}, React.createElement("feOffset", {
  dx: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 3
}), React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0 0 0 0 0 0.137254902 0 0 0 0 0.149019608 0 0 0 0.25 0"
}), React.createElement("feMerge", null, React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  filter: "url(#a)",
  transform: "translate(-26 -374)"
}, React.createElement("path", {
  d: "M26 374h48v36H26z"
}), React.createElement("path", {
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M38.035 384.076L42.11 380l2.616 2.617 2.558-2.558 2.672 2.673 2.673-2.673 2.63 2.63L57.95 380l4.077 4.076-2.693 2.693 2.588 2.588-2.676 2.676 2.676 2.677-2.55 2.55 2.655 2.656-4.077 4.076-2.652-2.652-2.66 2.66-2.673-2.673L47.292 404l-2.595-2.595-2.586 2.587-4.076-4.076 2.59-2.59L38 394.702l2.676-2.676L38 389.35l2.654-2.654-2.62-2.62z"
}));

var SvgIcNavSwatchlib = function SvgIcNavSwatchlib(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 48,
    height: 36,
    viewBox: "0 0 48 36",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcNavSwatchlib, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-nav-swatchlib.a1b4346e.svg";
export { ForwardRef as ReactComponent };